var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bag" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _vm._v("\n      当前触发器：" + _vm._s(_vm.form.name) + "\n      "),
            _c(
              "el-popover",
              {
                ref: "popoverRef",
                attrs: { placement: "bottom", width: "400", trigger: "click" },
              },
              [
                _c(
                  "div",
                  [
                    _c("el-input", {
                      staticStyle: { width: "250px" },
                      attrs: { placeholder: "请输入触发器名称", size: "small" },
                      model: {
                        value: _vm.value,
                        callback: function ($$v) {
                          _vm.value = $$v
                        },
                        expression: "value",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "ml14",
                        attrs: { size: "small", type: "text" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("取消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.nameSubmit },
                      },
                      [_vm._v("确定")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", {
                  staticClass: "el-icon-edit-outline",
                  attrs: { slot: "reference" },
                  slot: "reference",
                }),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mr24 flex" }, [
          _c("div", { staticClass: "btn btn-left", on: { click: _vm.save } }, [
            _vm._v("仅保存"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn btn-right",
              on: {
                click: function ($event) {
                  return _vm.save(1)
                },
              },
            },
            [_vm._v("保存并关闭")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-timeline",
            _vm._l(_vm.activities, function (item, index) {
              return _c(
                "el-timeline-item",
                { key: index, attrs: { icon: item.icon, color: item.color } },
                [
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                  _vm._v(" "),
                  item.id === 1
                    ? _c(
                        "div",
                        { staticClass: "phase_1" },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "form",
                              refInFor: true,
                              attrs: {
                                model: _vm.form,
                                "label-width": "100px",
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "应用实体" } },
                                [_c("div", [_vm._v(_vm._s(_vm.crud_name))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "触发动作" } },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: {
                                        change: function ($event) {
                                          return _vm.actionChange()
                                        },
                                      },
                                      model: {
                                        value: _vm.action,
                                        callback: function ($$v) {
                                          _vm.action = $$v
                                        },
                                        expression: "action",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { width: "430px" } },
                                        _vm._l(
                                          _vm.actionList,
                                          function (item, index) {
                                            return _c(
                                              "el-checkbox",
                                              {
                                                key: index,
                                                attrs: {
                                                  label: item.value,
                                                  disabled:
                                                    _vm.info.event ===
                                                      "data_check" &&
                                                    ![
                                                      "create",
                                                      "update",
                                                    ].includes(item.value),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.label) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.action &&
                                  _vm.action.length > 0 &&
                                  _vm.action.includes("timer")
                                    ? [
                                        _vm._v(
                                          "\n                执行周期：\n                "
                                        ),
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              size: "small",
                                              placeholder: "请选择",
                                            },
                                            model: {
                                              value: _vm.form.timer_type,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "timer_type",
                                                  $$v
                                                )
                                              },
                                              expression: "form.timer_type",
                                            },
                                          },
                                          _vm._l(
                                            _vm.timeOptions,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.form.timer_type == 5
                                          ? _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.timer_options
                                                      .weekday,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form.timer_options,
                                                      "weekday",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.timer_options.weekday",
                                                },
                                              },
                                              _vm._l(
                                                _vm.weekOptions,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.value,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.value,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.form.timer_type == 7
                                          ? _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "160px" },
                                                attrs: {
                                                  placeholder: "请输入",
                                                  type: "number",
                                                  size: "small",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.numberChange(
                                                      "month",
                                                      12
                                                    )
                                                  },
                                                  change: function ($event) {
                                                    return _vm.numberChange(
                                                      "month",
                                                      12
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.timer_options
                                                      .month,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form.timer_options,
                                                      "month",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.timer_options.month",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-16",
                                                    attrs: { slot: "suffix" },
                                                    slot: "suffix",
                                                  },
                                                  [_vm._v("月")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        ["6", "7", "3"].includes(
                                          _vm.form.timer_type
                                        )
                                          ? _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "160px" },
                                                attrs: {
                                                  placeholder: "请输入",
                                                  type: "number",
                                                  size: "small",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.numberChange(
                                                      "day",
                                                      31
                                                    )
                                                  },
                                                  change: function ($event) {
                                                    return _vm.numberChange(
                                                      "day",
                                                      31
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.timer_options.day,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form.timer_options,
                                                      "day",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.timer_options.day",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-16",
                                                    attrs: { slot: "suffix" },
                                                    slot: "suffix",
                                                  },
                                                  [_vm._v("日")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !["0", "1"].includes(
                                          _vm.form.timer_type
                                        )
                                          ? _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "160px" },
                                                attrs: {
                                                  placeholder: "请输入",
                                                  type: "number",
                                                  size: "small",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.numberChange(
                                                      "hour",
                                                      59
                                                    )
                                                  },
                                                  change: function ($event) {
                                                    return _vm.numberChange(
                                                      "hour",
                                                      59
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.timer_options.hour,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form.timer_options,
                                                      "hour",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.timer_options.hour",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-16",
                                                    attrs: { slot: "suffix" },
                                                    slot: "suffix",
                                                  },
                                                  [_vm._v("时")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.form.timer_type != "0"
                                          ? _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "160px" },
                                                attrs: {
                                                  placeholder: "请输入",
                                                  type: "number",
                                                  size: "small",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.numberChange(
                                                      "minute",
                                                      59
                                                    )
                                                  },
                                                  change: function ($event) {
                                                    return _vm.numberChange(
                                                      "minute",
                                                      59
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.timer_options
                                                      .minute,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form.timer_options,
                                                      "minute",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.timer_options.minute",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-16",
                                                    attrs: { slot: "suffix" },
                                                    slot: "suffix",
                                                  },
                                                  [_vm._v("分")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        ["4", "5", "6", "0"].includes(
                                          _vm.form.timer_type
                                        )
                                          ? _c(
                                              "el-input",
                                              {
                                                staticStyle: { width: "160px" },
                                                attrs: {
                                                  placeholder: "请输入",
                                                  type: "number",
                                                  size: "small",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.numberChange(
                                                      "second",
                                                      59
                                                    )
                                                  },
                                                  change: function ($event) {
                                                    return _vm.numberChange(
                                                      "second",
                                                      59
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.timer_options
                                                      .second,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form.timer_options,
                                                      "second",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.timer_options.second",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-16",
                                                    attrs: { slot: "suffix" },
                                                    slot: "suffix",
                                                  },
                                                  [_vm._v("秒")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "prompt mt10 ml50" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getStr(
                                                    _vm.form.timer_type
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _vm.info.event !== "get_data"
                                ? _c(
                                    "el-form-item",
                                    { attrs: { label: "附加过滤条件" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "default-color pointer fz-12",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.OpenSettings(
                                                    "additional_search"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.form
                                                      .additional_search &&
                                                      _vm.form.additional_search
                                                        .length > 0
                                                      ? "已设置条件（" +
                                                          _vm.form
                                                            .additional_search
                                                            .length +
                                                          "）"
                                                      : "点击设置"
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "prompt" }, [
                                        _vm._v(
                                          "只有满足指定条件的实体操作才会触发该触发器"
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.id === 2
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form",
                            {
                              ref: "form",
                              refInFor: true,
                              attrs: {
                                model: _vm.form,
                                "label-width": "100px",
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "执行操作" } },
                                [_c("div", [_vm._v(_vm._s(_vm.event_name))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "操作内容" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "box" },
                                    [
                                      _c(
                                        "el-form",
                                        {
                                          ref: "form",
                                          refInFor: true,
                                          attrs: {
                                            model: _vm.form,
                                            "label-width": "90px",
                                          },
                                        },
                                        [
                                          _vm.info.event === "data_check"
                                            ? [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "校验条件",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "default-color pointer fz-12",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.OpenSettings(
                                                                  "testOptions"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.form
                                                                  .testOptions &&
                                                                  _vm.form
                                                                    .testOptions
                                                                    .length > 0
                                                                  ? "已设置条件（" +
                                                                      _vm.form
                                                                        .testOptions
                                                                        .length +
                                                                      "）"
                                                                  : "点击设置"
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "prompt" },
                                                      [
                                                        _vm._v(
                                                          "符合校验条件的数据/记录在操作时会提示失败"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.info.event === "send_notice"
                                            ? [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "接受人员",
                                                    },
                                                  },
                                                  [
                                                    _c("select-member", {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        value:
                                                          _vm.userList || [],
                                                        placeholder: "选择成员",
                                                      },
                                                      on: {
                                                        getSelectList:
                                                          _vm.getSelectList,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "mt14",
                                                    attrs: {
                                                      label: "通知类型",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-checkbox-group",
                                                      {
                                                        model: {
                                                          value:
                                                            _vm.notify_type,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.notify_type =
                                                              $$v
                                                          },
                                                          expression:
                                                            "notify_type",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-checkbox",
                                                          {
                                                            attrs: { label: 0 },
                                                          },
                                                          [_vm._v("通知")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "mt14",
                                                    attrs: {
                                                      label: "推送标题",
                                                    },
                                                  },
                                                  [
                                                    _c("el-input", {
                                                      staticClass:
                                                        "textPosition",
                                                      attrs: {
                                                        placeholder:
                                                          "请输入推送标题",
                                                      },
                                                      on: {
                                                        input: _vm.onInput,
                                                      },
                                                      model: {
                                                        value: _vm.form.title,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "title",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.title",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "left",
                                                          width: "100",
                                                          trigger: "hover",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "field-box",
                                                          },
                                                          _vm._l(
                                                            _vm.field,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "field-text over-text",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleClick(
                                                                          item,
                                                                          1
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        item.label
                                                                      ) +
                                                                      "\n                          "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "el-icon-chat-dot-square icon",
                                                          attrs: {
                                                            slot: "reference",
                                                          },
                                                          slot: "reference",
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "prompt mt14",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        标题支持字段变量，如 "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "color-file",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "{createdOn}"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " (其中 createdOn\n                        为源实体的字段内部标识)\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          [
                                            "send_notice",
                                            "data_check",
                                          ].includes(_vm.info.event)
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  staticClass: "mt14",
                                                  attrs: {
                                                    label:
                                                      _vm.info.event ==
                                                      "data_check"
                                                        ? "提示内容"
                                                        : "推送内容",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticClass: "textPosition",
                                                    attrs: {
                                                      type: "textarea",
                                                      rows: 3,
                                                      placeholder:
                                                        "请输入推送内容",
                                                    },
                                                    model: {
                                                      value: _vm.form.template,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "template",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.template",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "prompt" },
                                                    [
                                                      _vm._v(
                                                        "校验未通过时的提示内容。内容支持字段变量，如 "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "color-file",
                                                        },
                                                        [_vm._v("{createdOn} ")]
                                                      ),
                                                      _vm._v(
                                                        "(其中\n                      createdOn 为源实体的字段内部标识)"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-popover",
                                                    {
                                                      attrs: {
                                                        placement: "left",
                                                        width: "100",
                                                        trigger: "hover",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "field-box",
                                                        },
                                                        _vm._l(
                                                          _vm.field,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: index,
                                                                staticClass:
                                                                  "field-text over-text",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleClick(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      item.label
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass:
                                                          "el-icon-chat-dot-square icon",
                                                        attrs: {
                                                          slot: "reference",
                                                        },
                                                        slot: "reference",
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          [
                                            "auto_revoke_approve",
                                            "auto_approve",
                                          ].includes(_vm.info.event)
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "选择审批流程",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "300px",
                                                      },
                                                      attrs: {
                                                        size: "small",
                                                        placeholder:
                                                          _vm.info.event ===
                                                          "auto_approve"
                                                            ? "请选择审批流程"
                                                            : "请搜索选择关联撤销记录",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .crud_approve_id,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "crud_approve_id",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.crud_approve_id",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.approval,
                                                      function (item, index) {
                                                        return _c("el-option", {
                                                          key: index,
                                                          attrs: {
                                                            label: item.name,
                                                            value: item.id,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "prompt mt14",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.info.event ===
                                                              "auto_approve"
                                                              ? "需要先添加审批流程才能在此处选择"
                                                              : "可撤销源实体记录或其他关联记录"
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.info.event === "to_do_schedule"
                                            ? [
                                                _c("to-do-schedule", {
                                                  ref: "toDoSchedule",
                                                  refInFor: true,
                                                  attrs: {
                                                    data: _vm.form.options,
                                                    options: _vm.relatedData,
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.info.event === "get_data" ||
                                          _vm.info.event === "push_data"
                                            ? [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label: "链接地址",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "300px",
                                                        },
                                                        attrs: {
                                                          size: "small",
                                                          filterable: "",
                                                          placeholder:
                                                            "链接地址",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form.curl_id,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "curl_id",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.curl_id",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.dataList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.title,
                                                                value: item.id,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "mb14" },
                                                      [
                                                        _vm.info.event ==
                                                        "get_data"
                                                          ? _c(
                                                              "el-button",
                                                              {
                                                                staticClass:
                                                                  "mt10",
                                                                attrs: {
                                                                  type: "primary",
                                                                  loading:
                                                                    _vm.curlLoading,
                                                                  size: "small",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.crudSendFn(
                                                                        1
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "测试请求"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.info.event == "get_data"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "prompt mb20",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        注意：必须执行完测试请求之后，源字段中才会有对应的数据\n                      "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          [
                                            "field_update",
                                            "field_aggregate",
                                            "group_aggregate",
                                            "auto_create",
                                            "get_data",
                                            "push_data",
                                          ].includes(_vm.info.event)
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "目标实体" },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "300px",
                                                      },
                                                      attrs: {
                                                        size: "small",
                                                        filterable: "",
                                                        placeholder:
                                                          "应用实体名称",
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.changeTargetCrudId,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .target_crud_id,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "target_crud_id",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.target_crud_id",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.targetEntity,
                                                      function (item, index) {
                                                        return _c("el-option", {
                                                          key: index,
                                                          attrs: {
                                                            label:
                                                              item.table_name,
                                                            value: item.id,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.info.event === "group_aggregate"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  staticClass: "mt14",
                                                  attrs: {
                                                    label: "聚合目标条件",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "default-color pointer fz-12",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.OpenSettings(
                                                                "aggregate_target_search"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.form
                                                                  .aggregate_target_search &&
                                                                  _vm.form
                                                                    .aggregate_target_search
                                                                    .length > 0
                                                                  ? "已设置条件（" +
                                                                      _vm.form
                                                                        .aggregate_target_search
                                                                        .length +
                                                                      "）"
                                                                  : "点击设置"
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "prompt" },
                                                    [
                                                      _vm._v(
                                                        "仅会聚合到符合条件的数据上"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.info.event === "get_data"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  staticClass: "mt14",
                                                  attrs: {
                                                    label: "重复数据处理",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      model: {
                                                        value:
                                                          _vm.form.options
                                                            .is_skip_value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form.options,
                                                            "is_skip_value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.options.is_skip_value",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: { label: "0" },
                                                        },
                                                        [_vm._v("跳过")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: { label: "1" },
                                                        },
                                                        [_vm._v("更新")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          [
                                            "field_update",
                                            "field_aggregate",
                                            "group_aggregate",
                                            "auto_create",
                                            "get_data",
                                            "push_data",
                                          ].includes(_vm.info.event)
                                            ? [
                                                _c("updateContent", {
                                                  ref: "updateContent",
                                                  refInFor: true,
                                                  attrs: {
                                                    type: _vm.info.event,
                                                    list: _vm.getOptions(
                                                      _vm.info.event
                                                    ),
                                                    groupList: _vm.groupList,
                                                    options: _vm.options,
                                                    uniqidOptions:
                                                      _vm.uniqidOptions,
                                                    groupField: _vm.groupField,
                                                    targetField:
                                                      _vm.targetField,
                                                    action: _vm.action,
                                                    field: _vm.field,
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.info.event ===
                                            "field_aggregate" ||
                                          _vm.info.event === "group_aggregate"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  staticClass: "mt14",
                                                  attrs: {
                                                    label: "聚合数据条件",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "default-color pointer fz-12",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.OpenSettings(
                                                                "aggregate_data_search"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.form
                                                                  .aggregate_data_search &&
                                                                  _vm.form
                                                                    .aggregate_data_search
                                                                    .length > 0
                                                                  ? "已设置条件（" +
                                                                      _vm.form
                                                                        .aggregate_data_search
                                                                        .length +
                                                                      "）"
                                                                  : "点击设置"
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "prompt" },
                                                    [
                                                      _vm._v(
                                                        "仅会聚合到符合过滤条件的数据上"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { attrs: { label: "执行优先级" } },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "220px" },
                                    attrs: { min: 0, size: "small" },
                                    model: {
                                      value: _vm.form.sort,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "sort", $$v)
                                      },
                                      expression: "form.sort",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "prompt mt14" }, [
                                    _vm._v(
                                      "优先级高（数字大）的会被先执行，优先级相等的先执行创建早的触发器"
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "请求数据", visible: _vm.isRequest, width: "50%" },
          on: {
            "update:visible": function ($event) {
              _vm.isRequest = $event
            },
          },
        },
        [
          _c("json-viewer", {
            staticStyle: { height: "600px", width: "100%" },
            attrs: { value: _vm.jsonData, "expand-depth": 8, copyable: "" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          staticClass: "condition_copyer",
          attrs: {
            size: "650px",
            direction: "rtl",
            title: "条件设置",
            "append-to-body": true,
            wrapperClosable: false,
            visible: _vm.$store.state.business.conditionDialog,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(
                _vm.$store.state.business,
                "conditionDialog",
                $event
              )
            },
          },
        },
        [
          _vm.$store.state.business.conditionDialog
            ? _c("condition-dialog", {
                attrs: {
                  id: _vm.crud_id,
                  eventStr: "event",
                  additionalBoolean: _vm.additional_boolean,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }